<template>
    <section class="result container" v-if="results?.length">
        <h2 class="result__header">Search results</h2>
        <div class="result__block">
            <div class="result__media">
                <img :src="thumb" alt="" class="result__img">
                <img src="/img/result/play.svg" alt="" class="result__play">
            </div>
            <div class="search-result__item-info">
                <div class="search-result__item-info-table">
                    <div class="search-result-download-head search__result-head quality">
                        <div class="search__result-download-head-quality search-result__item-info-table-item-title search__result-quality">quality</div>
                        <div class="search__result-download-head-quality search-result__item-info-table-item-title search__result-download">download</div>
                    </div>
                    <div class="search-result-download-main search__result-main">
                        <div 
                            v-for="(result, index) in results" 
                            :key="index" 
                            class="search-result-download-main-item search__result-main-item"
                        >
                            <div class="search-result-download-main-quality search__result-quality">
                                <span>{{ result.ext.toUpperCase() }} {{ getQualityLabel(result) }}</span>
                                <img 
                                    v-if="result.with_watermark" 
                                    src="/img/watermark.svg" 
                                    alt="Watermark Icon" 
                                    class="custom-svg-img"
                                />
                            </div>
                            <div class="search-result__item-info-table-item-info search__result-button">
                                <button v-bind:class="[video ? 'result__btn_alt' : '', 'result__btn']" @click="downloadItem(result.ext)">
                                    <a :href="result.url" download>Download</a>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="search-result-texts">
                    <p class="search-result__item-info-author search-result-author">{{ username }}</p>
                    <p class="search-result__item-info-author search-result-text">{{ title }}</p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "SearchResult",
    data() {
        return {
            thumb: null,
            title: null,
            username: null,
            results: [],
            isArray: null
        };
    },
    created() {
        this.$root.$on('tt-result-received', (data) => {
            this.isArray = Array.isArray(data);

            if (!this.isArray) {
                const userNameMatch = data?.meta?.source.match(/(?<=com\/)\@[^\/]+/);
                this.thumb = data?.thumb || null;
                this.title = data?.meta?.title || null;
                this.username = userNameMatch ? userNameMatch[0] : '';
                this.results = data.url;
            }
        });

        this.$root.$on('clear-results', this.clearResults);
    },
    beforeDestroy() {
        this.$root.$off('tt-result-received', this.handleResultReceived);
        this.$root.$off('clear-results', this.clearResults);
    },
    methods: {
        clearResults() {
            this.thumb = null;
            this.title = null;
            this.username = null;
            this.results = [];
        },
        downloadItem(type) {
            this.$root.$emit('download-click', type);
        },
        bytesToMB(bytes) {
            return (bytes / (1024 * 1024)).toFixed(2);
        },
        getQualityLabel(result) {
            if (result.ext === 'mp3') {
                return '';
            } else if (result.ext === 'mp4') {
                if (result.subname === '540') {
                    return '(SD)'; 
                } else if (result.subname === '720') {
                    return '(HD)'; 
                }
            }
            return `(${result.subname || 'N/A'})`;
        }
    }
};
</script>